/**
 * Watrly Button Component
 * =======================
 * مكون الزر الأساسي
 */

import React, { forwardRef } from 'react';
import { useTheme } from '../../context/ThemeContext';
import './Button.css';

const Button = forwardRef(({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = 'start',
  type = 'button',
  className = '',
  onClick,
  ...props
}, ref) => {
  const { isRTL } = useTheme();

  const baseClasses = 'watrly-btn';
  const variantClasses = `watrly-btn--${variant}`;
  const sizeClasses = `watrly-btn--${size}`;
  const stateClasses = [
    fullWidth && 'watrly-btn--full',
    disabled && 'watrly-btn--disabled',
    loading && 'watrly-btn--loading',
    icon && !children && 'watrly-btn--icon-only',
  ].filter(Boolean).join(' ');

  const classes = [baseClasses, variantClasses, sizeClasses, stateClasses, className]
    .filter(Boolean)
    .join(' ');

  const iconElement = icon && (
    <span className={`watrly-btn__icon watrly-btn__icon--${iconPosition}`}>
      {icon}
    </span>
  );

  const loadingSpinner = (
    <span className="watrly-btn__spinner">
      <svg className="watrly-btn__spinner-svg" viewBox="0 0 24 24">
        <circle
          className="watrly-btn__spinner-circle"
          cx="12"
          cy="12"
          r="10"
          fill="none"
          strokeWidth="3"
        />
      </svg>
    </span>
  );

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      dir={isRTL ? 'rtl' : 'ltr'}
      {...props}
    >
      {loading && loadingSpinner}
      {!loading && iconPosition === 'start' && iconElement}
      {children && <span className="watrly-btn__text">{children}</span>}
      {!loading && iconPosition === 'end' && iconElement}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
